import loadable from "@loadable/component";
import useUser from "client/hooks/useUser";
import userMeetsPersonalizationCriteria from "client/utils/userMeetsPersonalizationCriteria";
import React, { useMemo } from "react";
import {
  AmpContentBannerConfig,
  AmpPersonalContentBannersContainer,
  AmpTabPersonalContentBanner,
} from "types/amplience";
import type { ContentBanner1Props } from "./ContentBanner1";

export interface ContentBanner1PersonalContainerProps extends Omit<ContentBanner1Props, "config"> {
  config: AmpPersonalContentBannersContainer | AmpTabPersonalContentBanner;
  maxBanners?: number;
}

const ContentBanner1 = loadable(() => import(/* webpackChunkName: "ContentBanner1" */ "./ContentBanner1"));

export const ContentBanner1PersonalContainer: React.FC<ContentBanner1PersonalContainerProps> = ({
  config,
  maxBanners,
  ...props
}) => {
  const user = useUser();

  const personalisedBanner = useMemo(() => {
    const banners = config.components
      ?.map((content) =>
        userMeetsPersonalizationCriteria(user, content.personalization)
          ? (content.component as AmpContentBannerConfig)
          : undefined,
      )
      .filter((content) => content !== undefined);

    return !maxBanners ? banners : banners?.splice(0, maxBanners);
  }, [config.components, maxBanners, user]);

  return (
    <>
      {personalisedBanner?.map(
        (content) => content && <ContentBanner1 key={content._meta.deliveryId} config={content} {...props} />,
      )}
    </>
  );
};
